/** Faction choice shown before a player's first buy. */
import { createPortal } from 'react-dom';
import { FACTIONS } from '../config/factions';

export const FACTION_CHOICE_KEY = 'nt3d_faction_choice';

interface Props {
  open: boolean;
  current: number;
  onChoose: (contractId: number) => void;
  onClose: () => void;
}

export default function FactionChoiceModal({ open, current, onChoose, onClose }: Props) {
  if (!open) return null;
  return createPortal(
    <div className="fixed inset-0 z-[400] flex items-center justify-center p-4 bg-black/85 backdrop-blur-sm" onClick={onClose}>
      <div className="w-full max-w-2xl rounded-2xl border border-neon-cyan/40 bg-void-black p-5" onClick={e => e.stopPropagation()} role="dialog" aria-modal="true">
        <h2 className="font-orbitron text-xl text-neon-cyan mb-1">Choose your faction</h2>
        <p className="text-sm text-gray-400 mb-4">Your faction is locked for the round once you buy. Each faction has its own power and its own leaderboard.</p>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {FACTIONS.map(f => (
            <button
              key={f.contractId}
              onClick={() => onChoose(f.contractId)}
              className={`rounded-xl p-3 border text-left transition-all hover:scale-[1.03] ${current === f.contractId ? 'border-neon-cyan bg-neon-cyan/10' : 'border-white/10 bg-white/5'}`}
              style={{ boxShadow: `0 0 0 1px ${f.color}22` }}
            >
              <img src={f.icon} alt="" className="w-10 h-10 mb-2 object-contain" loading="lazy" />
              <div className="font-orbitron text-sm" style={{ color: f.color }}>{f.name}</div>
              <div className="text-[11px] text-gray-400 leading-tight">{f.power}</div>
            </button>
          ))}
        </div>
        <button onClick={onClose} className="mt-4 w-full py-2 text-sm text-gray-500 hover:text-white">Cancel</button>
      </div>
    </div>,
    document.body,
  );
}
